import * as moment from "moment";
import {ErrorIcon, StatusIcon} from "../Icons";
import React from "react";

export const Status = (props) => {
    let statusDecided = false;
    let extraMessage = "";
    let icon = null;

    if (props.validFromDate) {
        const now = moment.utc();
        const validFromDate = moment.utc(props.validFromDate);
        if (now < validFromDate) {
            extraMessage = "valid from " + props.validFromDate;
            icon = <ErrorIcon marginRight={"5px"}/>;
            statusDecided = true;
        }
    }
    if (props.validToDate) {
        const now = moment.utc();
        const validToDate = moment.utc(props.validToDate);
        if (now > validToDate) {
            extraMessage = "valid from " + props.validToDate;
            icon = <ErrorIcon marginRight={"5px"}/>;
            statusDecided = true;
        }
    }
    if (statusDecided) {
        return <span>{icon}{props.status} ({extraMessage})</span>
    }

    icon = StatusIcon(props);
    return <span>{icon}{props.status}</span>;
};


// WEBPACK FOOTER //
// ./src/components/results/Status.js